export function updateSearchHydrated(data) {
  return {
    type: 'SEARCH_HYDRATED_UPDATE',
    data,
  };
}

export function updateSearchValue(data) {
  return {
    type: 'SEARCH_VALUE_UPDATE',
    data,
  };
}

export function updateSearchResults(data) {
  return {
    type: 'SEARCH_RESULTS_UPDATE',
    data,
  };
}

export function updateSearchActiveFilter(data) {
  return {
    type: 'SEARCH_FILTER_UPDATE',
    data,
  };
}

export function updateSearchHistory(data) {
  return {
    type: 'SEARCH_HISTORY_UPDATE',
    data,
  };
}
